import { alpha, TableCell, Typography } from "@mui/material";

interface TopActionsCardSpaceRiskCellProps {
  spaceRiskImprovement: number;
}

const TopActionsCardSpaceRiskCell = ({
  spaceRiskImprovement,
}: TopActionsCardSpaceRiskCellProps) => {
  // check that spaceRiskImprovement is greater than 0
  let greaterThanZero = false;
  if (spaceRiskImprovement > 0) {
    greaterThanZero = true;
  }

  return (
    <TableCell>
      <Typography
        variant="caption"
        sx={{
          backgroundColor: (theme) => alpha(theme.palette.none.main, 0.1),
          color: (theme) => theme.palette.none.dark,
          width: "fit-content",
          padding: "4px 16px",
          borderRadius: 1,
          fontWeight: 700,
        }}
      >
        {greaterThanZero && "-"}
        {spaceRiskImprovement.toFixed(2)}
      </Typography>
    </TableCell>
  );
};

export default TopActionsCardSpaceRiskCell;
